<script setup>
import pebbleLogoX from '~/assets/img/pebble-logo-x.png'
</script>

<template>
  <NuxtLink to="/" class="transition-transform hover:scale-105">
    <img class="w-24" :src="pebbleLogoX" alt="Pebble" />
  </NuxtLink>
</template>